import classNames from 'classnames'
import * as React from 'react'

import { useStickyShadow } from '../../../hooks/use-sticky-shadow'

export function StickyShadow(props: React.HTMLProps<HTMLDivElement>) {
  const { stickyRef, isSticky } = useStickyShadow()

  return (
    <div ref={stickyRef} className={classNames(props.className, 'pointer-events-none sticky left-0 w-full')}>
      <div
        className={classNames('h-full w-full shadow-md', {
          'opacity-100 transition-opacity duration-200': isSticky,
          'opacity-0': !isSticky,
        })}
      />
    </div>
  )
}
